/** Mirrors backend `MAX_ISSUES_PER_REPORT_PART` in app/interfaces/report.ts */
export const MAX_ISSUES_PER_REPORT_PART = 100;

/**
 * Mirrors `PdfService.createPartParamsForMultiIssue` — one PDF per part.
 * Single-issue and inspection reports always produce one file.
 */
export function estimateReportPdfFileCount(issueCount: number): number {
  if (issueCount <= 0) {
    return 1;
  }
  return Math.floor(issueCount / MAX_ISSUES_PER_REPORT_PART) + 1;
}
